
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  MicroConsultingClientEligibility,
  MicroConsultingFreelancerEligibility,
  MicroConsultingInfoResponse,
} from '../models';
import {
    MicroConsultingClientEligibilityFromJSON,
    MicroConsultingClientEligibilityToJSON,
    MicroConsultingFreelancerEligibilityFromJSON,
    MicroConsultingFreelancerEligibilityToJSON,
    MicroConsultingInfoResponseFromJSON,
    MicroConsultingInfoResponseToJSON,
} from '../models';

export interface GetMicroConsultingInfoRequest {
    profileId: string;
}

/**
 * 
 */
export class MicroConsultingApi extends runtime.BaseAPI {

    /**
     * Get micro-consulting eligibility for current user
          */
    async getClientEligibilityRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<MicroConsultingClientEligibility>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<MicroConsultingClientEligibility>({
            path: `/profile/api/micro-consulting/eligibility/client`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=MicroConsultingClientEligibilityFromJSON(response._data); }
        return response;
    }

    /**
     * Get micro-consulting eligibility for current user
          */
    async getClientEligibility(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<MicroConsultingClientEligibility> {
        const response = await this.getClientEligibilityRaw(initOverrides);
        return response._data;
    }

    /**
     * Get micro-consulting eligibility for current user
          */
    async getFreelancerEligibilityRaw(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<MicroConsultingFreelancerEligibility>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<MicroConsultingFreelancerEligibility>({
            path: `/profile/api/micro-consulting/eligibility/freelancer`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=MicroConsultingFreelancerEligibilityFromJSON(response._data); }
        return response;
    }

    /**
     * Get micro-consulting eligibility for current user
          */
    async getFreelancerEligibility(initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<MicroConsultingFreelancerEligibility> {
        const response = await this.getFreelancerEligibilityRaw(initOverrides);
        return response._data;
    }

    /**
     * Get micro-consulting info for given profile
          */
    async getMicroConsultingInfoRaw(requestParameters: GetMicroConsultingInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<MicroConsultingInfoResponse>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getMicroConsultingInfo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<MicroConsultingInfoResponse>({
            path: `/profile/api/profiles/{profileId}/micro-consulting`.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=MicroConsultingInfoResponseFromJSON(response._data); }
        return response;
    }

    /**
     * Get micro-consulting info for given profile
          */
    async getMicroConsultingInfo(requestParameters: GetMicroConsultingInfoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<MicroConsultingInfoResponse> {
        const response = await this.getMicroConsultingInfoRaw(requestParameters, initOverrides);
        return response._data;
    }

}
